import { useCallback } from 'react';
import CheckboxDropdown from 'components/elements/MultiSelect';

type Props = {
  value: string[];
  onChangeSelection: (arg0: string[], arg1: string) => void;
};

/**
 * Status filter only accepts 1 status, or none.
 * Transforms a multi-select selection into either `active`, `completed`, or
 * none (when both or neither are selected).
 */
export const normalizeProjectStatusFilter = (selection: string[]): string => {
  if (selection.includes('complete') && selection.includes('active')) {
    return '';
  }
  if (selection.includes('complete')) {
    return 'completed';
  }
  if (selection.includes('active')) {
    return 'active';
  }

  return '';
};

const StatusDropdownFilter = ({ value, onChangeSelection }: Props) => {
  const statusOptions = [
    { label: 'Active', key: 'active' },
    { label: 'Completed', key: 'complete' },
  ];

  const onChange = useCallback(
    (selectedKeys: string[]) => {
      const normalizedStatus = normalizeProjectStatusFilter(selectedKeys);
      onChangeSelection(selectedKeys, normalizedStatus);
    },
    [onChangeSelection],
  );

  return (
    <CheckboxDropdown
      selectedKeys={value}
      label="Status"
      options={statusOptions}
      onChangeSelection={onChange}
      placeholder="All"
    />
  );
};

export default StatusDropdownFilter;
